import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isLoadingWorldCup: false,
  isLoadingExcel: false,
  worldCupList: [],
  worldCupSelected: [],
  count: 0,
  page: 1,
  totalPages: 0,
  isUploadingGoals: false,
  uploadResult: {},
  isUpdatingGoal: false,
};

export const worldCupSlice = createSlice({
  name: "worldCup",
  initialState,
  reducers: {
    setLoading: (state, { payload }) => {
      state.isLoadingWorldCup = payload;
    },
    setWorldCup: (state, { payload }) => {
      state.worldCupList = payload.data;
      state.count = payload.count;
      state.page = payload.page;
      state.totalPages = payload.totalPages;
    },
    setSeletedWorldCupElement: (state, { payload }) => {
      state.worldCupSelected = payload;
    },
    setPage: (state, { payload }) => {
      state.page = payload;
    },
    setUploadingGoals: (state, { payload }) => {
      state.isUploadingGoals = payload;
    },
    setUploadResult: (state, { payload }) => {
      state.uploadResult = payload;
    },
    setUpdatingGoal: (state, { payload }) => {
      state.isUpdatingGoal = payload;
    },
    upsertWorldCupRow: (state, { payload }) => {
      const idx = state.worldCupList.findIndex((r) => r.id === payload.id);
      if (idx >= 0) {
        state.worldCupList[idx] = payload;
      } else {
        state.worldCupList = [payload, ...state.worldCupList];
      }
    },
  },
});
export const worldCupActions = worldCupSlice.actions;

export default worldCupSlice.reducer;
